<template>
    <div id="MessageCenter">
        <Head />
        <Login v-if="isLogin" @LoginOpen="openL" />
        <div class="message">
            <div class="leftNav">
                <decLeftNav ref="LeftNav" />
            </div>
            <main>
                <div class="title">
                    <div>
                        <i></i>
                        <h3>个人信息</h3>
                    </div>
                    <div class="btn" @click="dialogFormVisible = true">修改密码</div>
                    <el-dialog
                        width="30%"
                        title="修改密码"
                        style="text-align: center"
                        :visible.sync="dialogFormVisible"
                    >
                        <el-form :model="form">
                            <el-form-item label="原密码:" :label-width="formLabelWidth">
                                <el-input v-model="form.password" type="password" placeholder="请输入原密码"></el-input>
                            </el-form-item>
                            <el-form-item label="新密码:" :label-width="formLabelWidth">
                                <el-input
                                    placeholder="请输入新密码密码"
                                    type="password"
                                    v-model="form.password1"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码:" :label-width="formLabelWidth">
                                <el-input
                                    placeholder="请输入新密码密码"
                                    type="password"
                                    v-model="form.password2"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="changpswd">确 定</el-button>
                        </div>
                    </el-dialog>
                </div>
                <div class="container">
                    <!-- <el-table :show-header="true" :data="tableData" style="width: 100%">
            <el-table-column prop="name" width="300" ></el-table-column>
            <el-table-column prop="phone" style="width:100%"></el-table-column>
          </el-table>-->
                    <div>
                        <b>
                            姓
                            <span></span> 名：
                        </b>
                        <p>{{ message.Realname }}</p>
                    </div>
                    <div>
                        <b>手机号码：</b>
                        <p>{{ message.Phone }}</p>
                    </div>
                    <div>
                        <b>
                            地
                            <span></span> 址：
                        </b>
                        <p>{{ message.City }}</p>
                    </div>
                    <div>
                        <b>所在单位：</b>
                        <p>{{ message.CompanyName }}</p>
                    </div>
                    <div>
                        <b>所在部门：</b>
                        <p>{{ message.Department }}</p>
                    </div>
                    <div>
                        <b>
                            城
                            <span></span> 市：
                        </b>
                        <p>{{ message.City }}</p>
                    </div>
                    <div>
                        <b>电子邮箱：</b>
                        <p>{{ message.Email }}</p>
                    </div>
                </div>
            </main>
        </div>
        <Foot />
    </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import decLeftNav from "../../components/decLeftNav";
import Login from "../../components/Login";
export default {
    name: "MessageCenter",
    data() {
        return {
            isLogin: false,
            dialogFormVisible: false,
            form: {
                password: "",
                password1: "",
                password2: "",
            },
            formLabelWidth: "100px",

            ReportID: "",
            news: 0,
            message: {},
            // tableData: [
            //   {
            //     name: "姓    名:",
            //     phone: "张三"
            //   },
            //   {
            //     name: " 手机号:",
            //     phone: "15158778956"
            //   },
            //   {
            //     name: "省    份:",
            //     phone: "山东省"
            //   },
            //     {
            //     name: "所在单位:",
            //     phone: "山东淄矿集团分公司"
            //   },  {
            //     name: "所在部门:",
            //     phone: "研发部"
            //   },  {
            //     name: "职 称:",
            //     phone: "研发部长"
            //   },  {
            //     name: "城   市:",
            //     phone: "淄矿市"
            //   },  {
            //     name: "电子邮箱:",
            //     phone: "402146165@qq.com"
            //   }
            // ]
        };
    },
    components: {
        Head,
        Foot,
        Login,
        decLeftNav,
    },
    created() {
        window.scrollTo(0, sessionStorage.getItem("scroll"));
        let token = sessionStorage.getItem("token");
        this.$axios.post("welcome/info?token=" + token).then((res) => {
            console.log(res.data.data);
            this.message = res.data.data;
        });
    },
    mounted() {
        if (sessionStorage.getItem("isListGo") == "true") {
            this.ReportID = sessionStorage.getItem("reportID");
        } else {
            this.ReportID = sessionStorage.getItem("ReportID");
        }
        if (!sessionStorage.getItem("name")) {
            this.$router.replace("/Declare");
            return;
        }
        this.$refs.LeftNav.isTable();
        this.news = sessionStorage.getItem("msg");
        console.log(sessionStorage.getItem("userinfo"), 11);
        console.log(this.news, 11);
    },
    methods: {
        changpswd() {
            let that = this;
            for (var key in this.form) {
                if (!this.form[key]) {
                    this.$message({
                        message: "信息填写不完整,请重新输入",
                        type: "warning",
                    });
                    return;
                }
            }
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;

            if (!regex.test(this.form.password1)) {
                this.$message({
                    message: "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                    type: "warning",
                });
                return;
            }
            if (this.form.password1 != this.form.password2) {
                this.$message({
                    message: "两次输入密码不一致",
                    type: "warning",
                });
                return;
            }
            that.$axios
                .post("welcome/setpwd?token=" + sessionStorage.getItem("token"), that.$qs.stringify(that.form))
                .then((res) => {
                    if (res.data.code == 10000) {
                        that.$message({ message: "修改成功", type: "success" });
                        that.dialogFormVisible = false;
                        that.$axios.post("login/logout?token=" + sessionStorage.getItem("token")).then((res) => {
                            if (res.data.code == 10000) {
                                sessionStorage.clear();
                                that.$message(res.data.msg);
                                that.$router.replace("/");
                                location.reload();

                                // that.isLogin=true
                            } else {
                                that.$message(res.data.msg);
                            }
                        });
                    } else {
                        that.$message(res.data.msg);
                    }
                });
        },
    },
};
</script>
<style lang="less" scoped>
#MessageCenter {
    width: 100%;
    min-width: 1000px;
    .message {
        width: 100%;
        padding: 0 1.35rem;
        display: flex;
        align-items: stretch;
        margin-top: 0.6rem;
        font-size: 0.18rem;
        .leftNav {
            padding-right: 0.4rem;
            border-right: 0.01rem solid #e4e4e4;
        }
        main {
            width: 100%;
            margin-left: 0.3rem;
            padding: 0 2rem 0 0.5rem;

            .title {
                display: flex;
                justify-content: space-between;

                .btn {
                    font-size: 0.18rem;
                    cursor: pointer;
                    width: 0.94rem;
                    height: 0.34rem;
                    background: #2d65d2;
                    border-radius: 0.04rem;
                    color: white;
                    display: flex;
                    justify-content: center;
                }
                > div {
                    display: flex;
                    align-items: center;
                    i {
                        display: inline-block;
                        width: 0.3rem;
                        height: 0.3rem;
                        background-image: url("../../assets/Declare/geren1.png");
                        background-repeat: no-repeat;
                        background-size: 100%;
                        margin-right: 0.1rem;
                    }
                }
            }
            .container {
                margin-top: 0.5rem;
                div {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 0.01rem solid #d9d9d9;
                    line-height: 0.8rem;
                    b {
                        color: #505050;
                        font-size: 0.18rem;
                    }
                    span {
                        display: inline-block;
                        width: 0.25rem;
                    }
                    p {
                        width: 70%;
                        color: #181818;
                        font-size: 0.2rem;
                    }
                }
            }
        }
    }
}
</style>
